module.exports = __webpack_public_path__ + "media/icons/tapicerka-skorzana-active@2x-d8a89fc8.png";